import "bootstrap/dist/css/bootstrap.min.css";
// general js and styles
import "./src/styles/base.css";
import "typeface-lato";

import React from "react";
import Analytics from "analytics";
import googleTagManager from "@analytics/google-tag-manager";
import googleAnalytics from "@analytics/google-analytics";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
//import mixpanel from "mixpanel-browser";

import {
  REACT_APP_API_BASE_URL,
  REACT_APP_GEO_BASE_URL,
  REACT_APP_GTM_NAME,
  REACT_APP_GTM_CONTAINER_ID,
  REACT_APP_MEASUREMENT_ID_1,
  REACT_APP_MIXPANEL_TOKEN,
} from "gatsby-env-variables";
import { configureShared } from "@trailpix/shared";

// Shared (mobile + www) modules read their endpoints from here. The site only
// uses the unauthenticated `/public/...` routes.
configureShared({
  apiBaseUrl: REACT_APP_API_BASE_URL,
  geoBaseUrl: REACT_APP_GEO_BASE_URL,
  publicApi: true,
});

if (REACT_APP_GTM_NAME) {
  const analytics = Analytics({
    app: REACT_APP_GTM_NAME,
    plugins: [
      googleTagManager({
        containerId: REACT_APP_GTM_CONTAINER_ID,
      }),
      googleAnalytics({
        measurementIds: [REACT_APP_MEASUREMENT_ID_1],
      }),
    ],
  });

  if (typeof window !== undefined) {
    window.analytics = analytics;
  }
}

if (REACT_APP_MIXPANEL_TOKEN) {
  /*mixpanel.init(REACT_APP_MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    api_host: 'https://api-eu.mixpanel.com',
  })*/
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const wrapRootElement = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>
  );
};
